import request from '@/utils/request';

// /delete_guest_account 删除游客账号
export function delete_guest_account(data) {
	return request({
		url: '/delete_guest_account',
		method: 'post',
		data,
	});
}
// /user/bind_email 绑定邮箱
export function bindEmail(data) {
	return request({
		url: '/user/bind_email',
		method: 'post',
		data,
	});
}
// 用户信息查询 /game/access_token
export function queryAccessstoken(data) {
	return request({
		url: '/game/access_token',
		method: 'post',
		data,
	});
}
// 设置用户名 /user/set_username
export function setUsername(data) {
	return request({
		url: '/user/set_username',
		method: 'post',
		data,
	});
}
// 在线设备 /user/online_devices
export function onlineDevices(data) {
	return request({
		url: '/user/online_devices',
		method: 'post',
		data,
	});
}
// 在线设备登出 /user/kick_online_device
export function kickOnlineDevice(data) {
	return request({
		url: '/user/kick_online_device',
		method: 'post',
		data,
	});
}
// 解绑第三方账号 /user/unbind
export function unbind(data) {
	return request({
		url: '/user/unbind',
		method: 'post',
		data,
	});
}
// 验证身份返回csrf_token /user/check_terminal
export function check_terminal(data) {
	return request({
		url: '/user/check_terminal',
		method: 'post',
		data,
	});
}
// 换绑终端 /user/change_terminal
export function change_terminal(data) {
	return request({
		url: '/user/change_terminal',
		method: 'post',
		data,
	});
}
// 绑定终端 /user/bind_terminal
export function bind_terminal(data) {
	return request({
		url: '/user/bind_terminal',
		method: 'post',
		data,
	});
}
// 登录日志 /user/login_log
export function login_log(data) {
	return request({
		url: '/user/login_log',
		method: 'post',
		data,
	});
}
// 设备信息 设备信息 /user/device_info
export function deviceInfo(data) {
	return request({
		url: '/user/device_info',
		method: 'post',
		data,
	});
}
// agreement_section 网页协议类型获取
export function agreement_section(data) {
	return request({
		url: '/app/agreement_section',
		method: 'post',
		data,
	});
}
// /app/agreement_section_id
export function agreement_section_id(data) {
	return request({
		url: '/app/agreement_section_id',
		method: 'post',
		data,
	});
}
// /user/bind_accounts 第三方账号列表
export function bindAccounts(data) {
	return request({
		url: '/user/bind_accounts',
		method: 'post',
		data,
	});
}
// /user/upgrade
export function userUpgrade(data) {
	return request({
		url: '/user/upgrade',
		method: 'post',
		data,
	});
}
// /delete_guest_account 删除游客账号
export function deleteGuestAccount(data) {
	return request({
		url: '/user/delete_guest_account',
		method: 'post',
		data,
	});
}
// /user/send_verify_code_self 给自己发送手机(邮箱)验证码
export function send_verify_code_self(data) {
	return request({
		url: '/user/send_verify_code_self',
		method: 'post',
		data,
	});
}
// /user/set_password  设置密码
export function set_password(data) {
	return request({
		url: '/user/set_password',
		method: 'post',
		data,
	});
}
